import React, { useEffect, useContext, useState } from 'react'
import { Typography, Box, Button } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import TagManager from 'react-gtm-module'
import { PropertyContext } from './PropertyContext'
import { withRouter } from 'react-router-dom'
import crypto from 'crypto'
import { UserContext } from './UserContext'
import { sendDataToWebToLead } from './salesForce'

const Booked = ({ bookingValues }) => {
  const { property } = useContext(PropertyContext)
  const { user } = useContext(UserContext)
  const { t } = useTranslation()
  const [adbSub, setAdbSub] = useState(undefined)
  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'asyncAction',
        gaHitType: 'event',
        category: 'funnel visit',
        action: 'visit',
        label: `visit booked up`,
      },
    })
    var md5sum = crypto.createHash('md5')
    const md5 = md5sum.update(bookingValues.email).digest('hex')
    setAdbSub(md5)
  }, [])
  useEffect(() => {
    const sendToSalesForce = async () => {
      await sendDataToWebToLead({
        bookingValues,
        property,
      })
    }
    if (user.id && property.id) {
      sendToSalesForce()
    }
  }, [user, property])
  if (!property) {
    return null
  }
  return (
    <div className="w-full h-full p-4 md:w-8/12 lg:w-6/12 xl:w-5/12 flex flex-col items-center justify-center m-auto">
      {/* <Typography variant='body1'>{}</Typography> */}
      {adbSub && (
        <img
          src={`https://tracking.adgoon.it/SL1rR?adv_sub=${adbSub}`}
          width="1"
          height="1"
          style={{
            display: 'none',
          }}
        />
      )}
      <img src={`${process.env.REACT_APP_WEBSITE}/${property.images[0].url}`} className="w-full rounded-md" />
      <Box my={4}>
        <Typography align="center" variant="h6">
          {t('visit.booked', { date: moment(bookingValues.date).format('YYYY-MM-DD'), time: bookingValues.time })}
        </Typography>
      </Box>
      <div className="flex w-full flex-col items-center">
        <Button color="primary" variant="contained" size="large" onClick={() => window.close()}>
          {t('visit.action')}
        </Button>
      </div>
    </div>
  )
}

export default withRouter(Booked)
